import { Box, Grid, Typography } from "@mui/material";
import { navigationData as NavigationData } from "../types";
import { TransactionDetailsInBonds } from "./tables/transactionDetails";


const transactionDetailsDummy = [
    {
        "scheme": "DSP Short Term Fund Growth Plan",
        "schemeCategory": "Large-Cap",
        "transactionAmount": 15000,
        "transactionType": "Purchase",
        "transactionDate": "26/10/2023",
    },
    {
        "scheme": "Kotak Short Duration Fund Dividend Plan",
        "schemeCategory": "Short Duration",
        "transactionAmount": 150000,
        "transactionType": "Sale",
        "transactionDate": "27/10/2023",
    },
    {
        "scheme": "ICICI Prudential Infrastructure Fund",
        "schemeCategory": "Mid-Cap",
        "transactionAmount": 135000,
        "transactionType": "Purchase",
        "transactionDate": "28/10/2023",
    },
    {
        "scheme": "Kotak Short Duration Fund Dividend Plan",
        "schemeCategory": "Large-Cap",
        "transactionAmount": 35000,
        "transactionType": "Purchase",
        "transactionDate": "29/10/2023",
    },
    {
        "scheme": "SBI Short Term Debt Fund Growth Plan",
        "schemeCategory": "Mid-Cap",
        "transactionAmount": 12000,
        "transactionType": "Sale",
        "transactionDate": "30/10/2023",
    },


]
export default function BondsTransactionDetails(props: NavigationData): JSX.Element {
    const { clientCode } = props;
    return (
        // <Grid container>
        //     <Grid item sm={12} sx={{ width: '100%' }}>
        //         <TransactionDetailsInBonds
        //             tableData={transactionDetailsDummy}
        //             isLoading={false}
        //             clientCode={clientCode}

        //         />
        //     </Grid>
        // </Grid>
        <Typography variant="h1" sx={{ textAlign: 'center' }}>There are no transactions done yet.</Typography>
    )
}